import FormLabel from './FormLabel'

export * from './FormLabel'
export default FormLabel
